<template>
    <div>
        <el-card shadow="hover">
            <div>
                <template style="float: left;">
                    <el-button type="primary" size="small" icon="el-icon-document-add" @click="doAdd()">添加</el-button>
                    <el-button-group style="margin-left:20px;" v-show="selRows.length > 0">
                        <el-tooltip effect="dark" content="删除" placement="top">
                            <el-button size="small" icon="el-icon-delete" @click="doDelete()"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </template>
                <el-form style="float: right" inline :model="query" size="small">
                    <div @keydown.enter="doQuery()">
                        <el-form-item>
                            <el-select v-model="query.cid" placeholder="请选择栏目" style="width:200px;" @change="doQuery" clearable>
                                <el-option v-for="cata in catas" :key="cata.id" :label="cata.name" :value="cata.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.title" clearable placeholder="文章标题" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="查询" placement="top">
                                <el-button type="warning" size="small" icon="el-icon-search" circle @click="doQuery"></el-button>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="清空查询条件" placement="top">
                                <el-button size="small" icon="el-icon-refresh" circle @click="doReset"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </el-card>
        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" @selection-change="doSelectionChange" style="width: 100%">
                <el-table-column type="selection" width="40" />
                <el-table-column show-overflow-tooltip label="标题">
                    <template slot-scope="scope">
                        <p>{{ scope.row.title }}</p>
                        <p style="font-size: 0.75em;">
                            <el-tag size="mini" type="danger" style="margin-right: 10px;" effect="dark" v-if="!scope.row.show">不显示</el-tag>
                            <el-tag size="mini" type="success" style="margin-right: 10px;" effect="dark" v-if="scope.row.top">已置顶</el-tag>
                            <el-tag size="mini" type="warning" style="margin-right: 10px;" effect="dark" v-if="scope.row.rmd">已推荐</el-tag>
                            <span style="margin-right: 10px;" v-if="scope.row.publish">发布日期：{{ scope.row.publish }}</span>
                            <span>
                                点击量：
                                <b>{{ scope.row.hits }}</b>
                            </span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="栏目" width="200">
                    <template slot-scope="scope">
                        <span>{{ scope.row.cata.name }} [{{ scope.row.cata.tag }}]</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="排序值" width="80">
                    <template slot-scope="scope">
                        <span>{{ scope.row.sort }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="编辑时间" width="180">
                    <template slot-scope="scope">
                        <span>{{ scope.row.time }}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-edit" @click.stop="doEdit(scope.row)">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card shadow="hover" v-show="this.data.pages > 1" style="margin-top: 10px;">
            <el-pagination
                background
                @current-change="doChangePage"
                @size-change="doChangeSize"
                :current-page="this.data.page"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="this.query.size"
                layout="-> ,total,  prev, pager, next, jumper, sizes"
                :total="this.data.rows"
            />
        </el-card>
        <!--Form-->
        <el-dialog title="详情" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="formDialog" fullscreen>
            <el-form ref="form" :model="field" :rules="rules" label-width="80px">
                <el-row :gutter="10">
                    <el-col :span="16">
                        <el-form-item label="标题" prop="title">
                            <el-input v-model="field.title" placeholder="请填写文章标题"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="栏目" prop="cid">
                            <el-select v-model="field.cid" placeholder="请选择栏目" style="width:100%;">
                                <el-option v-for="cata in catas" :key="cata.id" :label="cata.name" :value="cata.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="专题" prop="sid">
                            <el-select v-model="field.sid" placeholder="请选择专题" style="width:100%;">
                                <el-option value="">无</el-option>
                                <el-option v-for="zt in zhuanti" :key="zt.id" :label="zt.title" :value="zt.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="副标题" prop="subhead">
                    <el-input v-model="field.subhead" placeholder="请填写副标题"></el-input>
                </el-form-item>
                <el-form-item label="导读" prop="intro">
                    <el-input type="textarea" :rows="2" v-model="field.intro" placeholder="请填写导读内容"></el-input>
                </el-form-item>
                <el-row :gutter="10">
                    <el-col :span="6">
                        <el-form-item label="作者" prop="author">
                            <el-input v-model="field.author" placeholder="请填写作者"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="来源" prop="source">
                            <el-input v-model="field.source" placeholder="请填写来源"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="外链地址" prop="linkurl">
                            <el-input v-model="field.linkurl" placeholder="请填写外链地址"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="5">
                        <el-form-item label="发布日期" prop="publish">
                            <el-date-picker v-model="field.publish" type="date" placeholder="请选择发布日期" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="排序值" prop="sort">
                            <el-input-number style="width: 100%;" size="small" v-model="field.sort" label="请填写排序值"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="点击量" prop="hits">
                            <el-input-number style="width: 100%;" size="small" v-model="field.hits" label="请填写点击量"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label="是否显示" prop="show">
                            <el-switch v-model="field.show" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label="是否置顶" prop="top">
                            <el-switch v-model="field.top" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label="是否推荐" prop="rmd">
                            <el-switch v-model="field.rmd" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="文章正文" prop="content">
                    <Tinymce ref="editor" v-model="field.content" :minh="500"></Tinymce>
                </el-form-item>
                <el-form-item label="文章附件" prop="files" style="width: 400px;">
                    <el-upload
                        action="action"
                        :before-upload="beforeUpload"
                        :http-request="handleUpload"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        multiple
                        :limit="5"
                        :on-exceed="handleExceed"
                        :file-list="fileList"
                    >
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">仅支持.doc/.docs/.xls/.xlsx/.zip文件，且不超过1MB</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="submitLoading" size="medium" icon="el-icon-circle-check" @click="doSubmit">
                    保存
                </el-button>
                <el-button type="info" plain size="medium" icon="el-icon-switch-button" @click="formDialog = false">
                    关闭
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Tinymce from '@/comps/Tinymce'
window.tinymce.baseURL = '/scripts/tinymce'

const defaultQuery = {
    page: 1,
    size: 10,
    time: 0,
    cid: '',
    title: ''
}
const defaultField = {
    id: '',
    cid: '',
    sid: '',
    title: '',
    subhead: '',
    intro: '',
    author: '',
    source: '',
    linkurl: '',
    content: '',
    publish: '',
    top: false,
    rmd: false,
    hlshow: false,
    show: true,
    sort: 0,
    hits: 0,
    files: '[]'
}
export default {
    name: 'CmsArticle',
    components: {
        Tinymce
    },
    data() {
        return {
            query: {
                ...defaultQuery
            },
            data: {
                rows: 0,
                pages: 0,
                page: 1,
                time: 0
            },
            tableLoading: false,
            datas: [],
            selRows: [],
            field: {
                ...defaultField
            },
            rules: {
                cid: [
                    {
                        required: true,
                        message: '请选择栏目',
                        trigger: 'blur'
                    }
                ],
                title: [
                    {
                        required: true,
                        message: '请填写标题',
                        trigger: 'blur'
                    }
                ],
                top: [
                    {
                        required: true,
                        message: '请选择是否置顶',
                        trigger: 'blur'
                    }
                ],
                rmd: [
                    {
                        required: true,
                        message: '请选择是否推荐',
                        trigger: 'blur'
                    }
                ],
                hlshow: [
                    {
                        required: true,
                        message: '请选择是否标题高亮',
                        trigger: 'blur'
                    }
                ],
                show: [
                    {
                        required: true,
                        message: '请选择是否显示',
                        trigger: 'blur'
                    }
                ],
                sort: [
                    {
                        required: true,
                        message: '请填写排序值',
                        trigger: 'blur'
                    }
                ],
                hits: [
                    {
                        required: true,
                        message: '请填写点击量',
                        trigger: 'blur'
                    }
                ]
            },
            formDialog: false,
            submitLoading: false,
            catas: [],
            zhuanti: [],
            fileList: []
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['网站管理', '文章管理'])
        this.init()
    },
    methods: {
        handleRemove(file) {
            this.fileList.splice(
                this.fileList.findIndex(f => f.uid == file.uid),
                1
            )
        },
        handleExceed(files, flist) {
            this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + flist.length} 个文件`)
        },
        beforeRemove(file) {
            if (file.name.endsWith('.doc') || file.name.endsWith('.docx') || file.name.endsWith('.xls') || file.name.endsWith('.xlsx') || file.name.endsWith('.zip')) {
                return this.$confirm(`确定移除 ${file.name}？`)
            }
            return true
        },
        beforeUpload(file) {
            const fileType = file.name.endsWith('.doc') || file.name.endsWith('.docx') || file.name.endsWith('.xls') || file.name.endsWith('.xlsx') || file.name.endsWith('.zip')
            const fileSize = file.size / 1024 <= 1024
            if (!fileType) {
                this.$message.error('上传文件只能是.doc/.docx/.xls/.xlsx/.zip格式!')
            }
            if (!fileSize) {
                this.$message.error('上传文件大小不能超过1MB!')
            }
            return fileSize && fileType
        },
        handleUpload(upload) {
            this.$http
                .post(
                    '/comm/base/file/upload',
                    {
                        file: upload.file,
                        type: 'AFiles'
                    },
                    {
                        onUploadProgress: progressEvent => {
                            const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0
                            upload.onProgress({
                                percent: complete
                            })
                        }
                    }
                )
                .then(result => {
                    if (result.code === 0) {
                        let obj = {
                            name: result.data.name,
                            url: result.data.url
                        }
                        this.fileList.push(obj)
                        upload.onSuccess(obj)
                    } else {
                        upload.onError()
                    }
                })
                .catch(err => {
                    upload.onError(err)
                })
        },
        init() {
            this.doLoad()
            this.doLoadCata()
            this.doLoadZhuanti()
        },
        doLoadCata() {
            this.$http
                .get('/comm/data/catalog/query', {
                    params: {
                        _: new Date().getTime()
                    }
                })
                .then(result => {
                    this.catas = result.datas
                })
        },
        doLoadZhuanti() {
            this.$http
                .get('/ops/cms/special/list', {
                    params: {
                        page: 1,
                        size: 999,
                        _: new Date().getTime()
                    }
                })
                .then(result => {
                    this.zhuanti = result.datas
                })
        },
        doLoad() {
            this.tableLoading = true
            this.$http
                .get('/ops/cms/article/list', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    this.data = result.data
                    this.datas = result.datas
                })
        },
        doQuery() {
            this.query.page = 1
            this.doLoad()
        },
        doReset() {
            this.query = {
                ...defaultQuery
            }
            this.doQuery()
        },
        doChangePage(num) {
            this.query.page = num
            this.doLoad()
        },
        doChangeSize(num) {
            this.query.page = 1
            this.query.size = num
            this.doLoad()
        },
        doSelectionChange(rows) {
            this.selRows = rows
        },
        clearFields() {
            this.field = {
                ...defaultField
            }
            if (this.$refs.editor) {
                this.$refs.editor.setContent('')
            }
            if (this.$refs['form']) {
                this.$refs['form'].resetFields()
                this.$refs['form'].clearValidate()
            }
        },
        doAdd() {
            this.clearFields()
            this.field.cid = this.catas.length > 0 ? this.catas[0].id : ''
            this.field.zid = this.zhuanti.length > 0 ? this.zhuanti[0].id : ''
            this.formDialog = true
        },
        doEdit(item) {
            this.clearFields()
            this.$http
                .get('/ops/cms/article/detail', {
                    params: {
                        id: item.id
                    }
                })
                .then(result => {
                    this.field = {
                        ...result.data
                    }
                    this.fileList = result.data.files
                    this.formDialog = true
                    if (this.$refs.editor) {
                        this.$refs.editor.setContent(this.field.content)
                    }
                })
        },
        doSubmit() {
            this.field.files = JSON.stringify(
                this.fileList.map(f => {
                    return {
                        name: f.name,
                        url: f.url
                    }
                })
            )
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    this.$http.post('/ops/cms/article/save', this.field).then(result => {
                        this.submitLoading = false
                        if (result.code === 0) {
                            this.doLoad()
                            this.formDialog = false
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                }
            })
        },
        doDelete(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.title)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.title)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要删除的内容')
                return
            }
            this.$confirm('是否删除[' + names.join() + ']?删除后将无法恢复', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/cms/article/delete', {
                        ids: ids.join()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('删除成功')
                            this.doLoad()
                        }
                    })
            })
        }
    }
}
</script>
